/* ------------------------------------------------------------------
団体ページにて、ログイン中の団体に対して特別なメッセージを表示させたい際に使う
--------------------------------------------------------------------- */
const initializeCurrentUserMsg = () => {
  if (document.getElementById("jsMsgForOwnRegUserPage")) {
    const userId = $("#jsMsgForOwnRegUserPage").data("userId");
    $.ajax({
      url: Routes.async_info_reg_user_current_user_path(userId),
      type: "GET",
      data: {},
      dataType: "script",
    });
  }
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeCurrentUserMsg;